import '@/common/css/base.scss';
import './overseas.scss';
import '@/common/js/base2.js';

$(document).ready(function() {
  setTimeout(() => {
    new Swiper('.swiper1', {
      watchSlidesProgress: true,
      slidesPerView: 'auto',
      centeredSlides: false,
      loop: true,
      // autoplay: true,
      // 如果需要分页器
      pagination: {
        el: '.swiper-pagination'
      },
      autoplay: {
        disableOnInteraction: false,
        delay: 2000
      },
      loopedSlides: 5
    });
    new Swiper('.swiper2', {
      direction: 'vertical',
      watchSlidesProgress: true,
      slidesPerView: 'auto',
      centeredSlides: false,
      loop: true,
      // autoplay: true,
      autoplay: {
        disableOnInteraction: false,
        delay: 2000
      },
      loopedSlides: 5
    });
  }, 1000);

  $('body').show();
  // www.carryu.com.cn

  var androidLight =
    'data:image/png;base64,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';
  var androidNormal =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAjCAYAAACD1LrRAAAAAXNSR0IArs4c6QAAAp5JREFUWEftl0uIzmEUh5+fOxs2bMZCpJB7JOUWRpHLxgZZSaLIRhkZd5mycslY2E1DsiJl0iTTKEYZl4mmJmXBhgU27vx0pvfTvzHfZcy/bOZsvr7vnPc833vec95zXlFGbC8HqiQ1lLMNve2twBtJd0rZq0JnjcB2SZ9K2dseBVyStLmc30rB84CNwEtgDTATGJecvwWeAE3AJOCapEf9BtseAuwFTgLDyjj8BhwAzkj68c+htj0GuA4sKbeDHvpWYL2kD8XWFQ217RHAXWBB5AzwGJgNDCriLGzagblA+G0Dlkn60pt9KfBZYHda1Cppie3bQHURcLOkatstmQidk7SnYrDtCUAXEOcb8hMI6EpgaBHwd6AZWAUMTjZxzpMlveq5ptcd2z4IHO/juRYzr5V0olJwqZD29f80SVpdKfhqqsm+Qnqz75K06S+w7YnAaWAsUC/piu0twPg8qMBrSY22A74TeAfsk+0HqWQKSTQLuAgsygl8D9gBPMskXVuAI2OztRn37K6cwReAy5mN/ApwFH5WIswRkjx3XA9Eo/kjA+AIxUCo+1tVUU4DyUWU03sgJo2CbIgrLec6jis5JpmCfAxwLXAs/fIcmJ96b54XSPToh8D0xDnU3Y9tx7hSFY1c0mfbMTPlBpa02PbINEjEzN1ebBCIWWtpf9M5rW+RtKzSfhyzVsxcechuSecrBUcktgErUiuLMxqdWdwJdKTvM4Ap2cRJORJd7xbQIKlnI+oeQ8uK7eilAShInaSalB+ngP0ZXYekeGmUlAFwr+H5n6GO12DMYgU5KulIOuP4PJzRPZUUT51czjiSJ5Io5CuwUFK8peLymQPcB4YnfY2kulzACbAOmArclPQi69j2NGAt0CnpRjlo6H8DxT4tWDpe9p0AAAAASUVORK5CYII=';
  $('.head-load span')
    .eq(0)
    .mouseover(function() {
      $(this)
        .find('img')
        .attr('src', androidLight);
    });
  $('.head-load span')
    .eq(0)
    .mouseout(function() {
      $(this)
        .find('img')
        .attr('src', androidNormal);
    });
  $('.head-load1 span')
    .eq(0)
    .click(function() {
      console.log('安卓下载');
      window.location.href = 'https://download.yuanhai777.com/download/woc_wocwoc.apk';
      // onTips();
    });
  $('.head-load1 span')
    .eq(1)
    .click(function() {
      console.log('ios下载');
      window.location.href = 'https://apps.apple.com/cn/app/id6443827162';
      // onTips();
    });

  // 点击logo
  // $('.head-tabber .img1').click(function() {
  //   location.href = './';
  // });
  $('.head-tabber .img2').click(function() {
    location.href = './home.html';
  });
  $('.beian').click(function() {
    window.open('http://beian.miit.gov.cn');
  });
  $('.foot1 .inforight').click(function() {
    window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=46010602001450');
  });
  $('.foot2 .inforight').click(function() {
    window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32021302000980');
  });
});
